/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Kb_Side_1Inputs */

const en_signin_kb_side_1 = /** @type {(inputs: Signin_Kb_Side_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agents can be assigned issues like teammates — and they work on the server, not on your laptop.`)
};

const id_signin_kb_side_1 = /** @type {(inputs: Signin_Kb_Side_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen AI dapat di-assign issue seperti rekan kerja — dan mengerjakannya di server, bukan di laptopmu.`)
};

/**
* | output |
* | --- |
* | "AI agents can be assigned issues like teammates — and they work on the server, not on your laptop." |
*
* @param {Signin_Kb_Side_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_kb_side_1 = /** @type {((inputs?: Signin_Kb_Side_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Kb_Side_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_kb_side_1(inputs)
	return en_signin_kb_side_1(inputs)
});